import Swal from "sweetalert2";

export class Utils {
  static alertWithMesssge(message: string, messagetype: string) {
    if (messagetype == "success") {
      Swal.fire({
         position: "top-end",
         title: "Success",
         icon: "success",
         text: message,
         showConfirmButton: false,
         timer: 2000
      });
    } else if (messagetype == "error") {

      Swal.fire({
        position: "top-end",
        //title: "Failure",
        icon: "error",
        text: message,
        showConfirmButton: false,
        timer: 5000
      });

    } else {
      Swal.fire({
        position: "top-end",
        //title: "Failure",
        icon: "error",
        text: "Something went wrong..!",
        showConfirmButton: false,
        timer: 2000
      });
    }
  }

  static alertWithMesssgeUpdated(message: string) {
    Swal.fire("Error", message, "error");
  }

  static alertWithMesssgeUpdatedForDaimlerID() {
    //swal("Please Read?", message, "question");
    Swal.fire({
      position: "center",
      //title: "Success",
      icon: "success",
      text: "Please Read the Message : LogBase requires Who Is Who / DSP ID for login, if necessary register the ID first / ログインにはWho is who IDまたはDSP IDが必要です。DFLユーザー情報登録未済でしたら、まず登録を行ってください",
      showConfirmButton: false,
      timer: 5000
    });

   // swal('Please Read Below Message', 'LogBase requires Who Is Who / DSP ID for login, if necessary register the ID first / ログインにはWho is who IDまたはDSP IDが必要です。DFLユーザー情報登録未済でしたら、まず登録を行ってください', 'success');
  }
}
